var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"contact-lens-image-type-switcher",attrs:{"type":"button"},on:{"click":_vm.next}},[_c('img',{staticClass:"icon",attrs:{"src":("/assets-proxy/images/icon-" + (_vm.nextOption.type) + ".svg")}})])}
var staticRenderFns = []

export { render, staticRenderFns }